<template>
  <tr>
    <td>{{ !extra ? period.work_type.name : period.work_extra_type.name }}</td>
    <td>
      {{
        !extra
          ? period.work_type.is_hourly === 0
            ? $roundNumberToTenths(period.size) + ' ' + period.work_type.measure
            : $formatTime(period.hours) +
              (period.size
                ? ' (' + $roundNumberToTenths(period.size) + ' ' + period.work_type.measure + ')'
                : '')
          : $formatTime(period.hours)
      }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'TimeControlShowEmployeeTableCurentDateItem',
  components: {},
  props: { period: Object, project: Object, tableHead: Array, min: Boolean, extra: Boolean },
  data: () => ({
    open: false,
  }),
}
</script>
